import Dialog from '@mui/material/Dialog'

import CloseIcon from '@mui/icons-material/Close'
import {
  StyledDiv,
  StyledErrorIcon,
  StyledButton,
  StyledDialogContent,
  StyledIconButton,
  StyledTypography,
  StyledSectionDividerLine
} from './PopupComponentStyle'
import PopupMessages from '../../common/PopupMessages/PopupMessages.json'
import {useProjectDetails} from '../../../store/hooks/projectDetails'
import buttonTitles from '../../../appConfig/buttonTitles.config.json'
import PropTypes from 'prop-types'

const PopupComponent = ({
  open,
  setOpen,
  popupStyle,
  createProject,
  resetAll,
  saveCurrent,
  setGoBack,
  setRenderUserView,
  isCompleted,
  renderUserView,
  projectDetails,
  clientWarning,
  toggleWarn
}) => {
  PopupComponent.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    popupStyle: PropTypes.object.isRequired,
    createProject: PropTypes.func.isRequired,
    resetAll: PropTypes.func.isRequired,
    saveCurrent: PropTypes.func.isRequired,
    setGoBack: PropTypes.func.isRequired,
    setRenderUserView: PropTypes.func.isRequired,
    isCompleted: PropTypes.bool.isRequired,
    renderUserView: PropTypes.bool.isRequired,
    projectDetails: PropTypes.object.isRequired,
    clientWarning: PropTypes.string.isRequired,
    toggleWarn: PropTypes.func.isRequired
  }

  const handleClose = () => {
    setOpen(false)
  }
  const {filters, jurisdiction, benefits, workforces, pointOfInterestsData} = useProjectDetails()

  const {
    currentGroupName,
    currentDescription,
    currentFilters,
    currentJurisdiction,
    currentDataAggregation,
    currentBenefits,
    currentWorkforces,
    currentPOI,
    setProjectName,
    setProjectDescription,
    setSelectedFilters,
    setSelectedBenefits,
    setSelectedWorkforces,
    setSelectedJurisdiction,
    setSelectedDataAggregation,
    setInputDisabled,
    setErrorTextEnabled,
    setSelectedUseCases,
    setSelectedPOI,
    setSelectedTrendAnalysis,
    setSelectedPersona,
    setSelectedChatbot,
    setSelectedChatbotExport,
    setSelectedChatbotCopy,
    setSelectedExportToggle,
    trendAnalysisFlag,
    personaFlag,
    chatbotFlag,
    chatbotExportFlag,
    chatbotCopyFlag,
    exportFlag,
    dataAggregationConfig
  } = projectDetails || {}
  const handleSelection = () => {
    setOpen(false)
    if (popupStyle === 'save') {
      saveCurrent(false)
    } else if (popupStyle === 'save and exit') {
      saveCurrent(true)
    } else if (popupStyle === 'back') {
      setGoBack(true)
    } else if (popupStyle === 'userManagement') {
      const dataAggregation = dataAggregationConfig?.data || []
      const resetDetails = {
        setErrorTextEnabled,
        createProject,
        setProjectName,
        setProjectDescription,
        setSelectedFilters,
        setSelectedJurisdiction,
        setSelectedDataAggregation,
        setSelectedBenefits,
        setSelectedWorkforces,
        setSelectedTrendAnalysis,
        setSelectedPersona,
        setSelectedChatbot,
        setSelectedChatbotExport,
        setSelectedChatbotCopy,
        setSelectedExportToggle,
        currentGroupName,
        currentDescription,
        filters,
        currentFilters,
        dataAggregation,
        currentDataAggregation,
        benefits,
        currentBenefits,
        workforces,
        currentWorkforces,
        jurisdiction,
        currentJurisdiction,
        trendAnalysisFlag,
        personaFlag,
        chatbotFlag,
        chatbotExportFlag,
        chatbotCopyFlag,
        exportFlag,
        setInputDisabled,
        setRenderUserView,
        renderUserView,
        pointOfInterestsData,
        setSelectedUseCases,
        setSelectedPOI,
        currentPOI
      }
      resetAll(resetDetails)
      setRenderUserView(true)
    } else {
      setGoBack(true)
    }
  }
  const checkPopupStyle = popupStyle === 'cancel' || popupStyle === 'back' || popupStyle === 'userManagement'
  const checkCreateProjectCancel = createProject && checkPopupStyle
  let heading = checkCreateProjectCancel ? PopupMessages.cancelWarningNewProject : PopupMessages.leaveWarning
  let bodyContent = checkCreateProjectCancel ? PopupMessages.cancelBodyNewProject : PopupMessages.leaveBody
  let bodyEnd = checkCreateProjectCancel ? PopupMessages.cancelBodyEnd : PopupMessages.leaveBodyEnd
  let selectionText = checkCreateProjectCancel
    ? PopupMessages.cancelOptionsMessageNewProject
    : PopupMessages.leaveOptionMessage
  const cancelText = checkCreateProjectCancel ? PopupMessages.cancelTextSpecial : 'Cancel'

  if (isCompleted && popupStyle !== 'save and exit') {
    heading = PopupMessages.cancelWarning
    bodyContent = PopupMessages.cancelBodyExistingProject
    bodyEnd = PopupMessages.cancelBodyEnd
    selectionText = PopupMessages.cancelOptionMessage
  }

  if (toggleWarn) {
    bodyContent = clientWarning ? PopupMessages.cancelBodyExistingProject : PopupMessages.cancelBodyNewClient
    bodyEnd = PopupMessages.cancelBodyEnd
  }
  return (
    <Dialog maxWidth='xs' open={open}>
      <StyledDialogContent tabIndex={0} aria-label='alert' dividers>
        <StyledIconButton title={buttonTitles.popupNotification} onClick={handleClose} aria-label='close-dialogue'>
          <CloseIcon style={{fontSize: (theme) => theme.typography.h6.fontSize}} />
        </StyledIconButton>
        <StyledSectionDividerLine />
        <StyledDiv hasPadding={true}>
          <StyledErrorIcon />
        </StyledDiv>
        <StyledDiv tabIndex={0} id={heading} textBold={true} hasPadding={true}>
          {heading}
        </StyledDiv>
        <StyledDiv hasPadding={true} />
        <StyledTypography tabIndex={0} id={bodyContent} gutterBottom>
          {bodyContent}
          <StyledDiv hasPadding={true}>{bodyEnd}</StyledDiv>
        </StyledTypography>
        <StyledDiv hasPadding={true}>
          <StyledButton onClick={handleSelection}>{selectionText}</StyledButton>
        </StyledDiv>
        <StyledDiv>
          <StyledButton isCancelButton={true} onClick={handleClose}>
            {cancelText}
          </StyledButton>
        </StyledDiv>
      </StyledDialogContent>
    </Dialog>
  )
}

export default PopupComponent
